"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = IdentityDocumentUpload;
exports.isErrorDocumentUploadState = isErrorDocumentUploadState;
exports.isValidDocumentUploadState = isValidDocumentUploadState;
var _react = _interopRequireDefault(require("react"));
var _thenRequest = _interopRequireDefault(require("then-request"));
var _alert = _interopRequireDefault(require("../core/alert"));
var _button = _interopRequireDefault(require("../core/button"));
var _FilePicker = _interopRequireDefault(require("./FilePicker"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* global STRIPE_PUBLIC */

function uploadIdentityDocument(file) {
  const form = new FormData();
  form.append('purpose', 'identity_document');
  form.append('file', file);
  const headers = {
    Accept: 'application/json',
    Authorization: 'Bearer ' + STRIPE_PUBLIC
  };
  return (0, _thenRequest.default)('POST', 'https://uploads.stripe.com/v1/files', {
    body: form,
    headers
  }).getBody('utf8').then(JSON.parse).then(result => {
    return result.id;
  }, err => {
    let message = 'Could not upload image';
    try {
      message = JSON.parse(err.body.toString('utf8')).error.message;
    } catch (ex) {
      // intentionally ignore this error
    }
    throw new Error(message);
  });
}
function usePreviewURL(file) {
  const ref = _react.default.useRef({
    file: null,
    preview: null
  });
  if (file !== ref.current.file) {
    ref.current.file = file;
    ref.current.preview = file ? URL.createObjectURL(file) : null;
  }
  _react.default.useEffect(() => {
    if (ref.current.preview) {
      const preview = ref.current.preview;
      return () => URL.revokeObjectURL(preview);
    } else {
      return () => {};
    }
  }, [ref.current.preview]);
  return ref.current.preview;
}
function isValidDocumentUploadState(s) {
  return !!(s && s.fileID != null);
}
function isErrorDocumentUploadState(s) {
  return !!(s && s.fileID == null);
}
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "Please check that the image is clear and of good quality");
function IdentityDocumentUpload({
  document,
  onChange,
  variant = 'identity'
}) {
  const preview = usePreviewURL(document && document.file);
  const currentFile = _react.default.useRef(document && document.file);
  currentFile.current = document && document.file;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("strong", null, variant === 'additional' ? 'Upload a second identity document or recent (no more than 6months old) utility bill that shows your address' : 'Upload a scanned image of your passport or driving licence (must be a jpeg, jpg or png)'), _ref, preview ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
    src: preview,
    width: 200
  })), /*#__PURE__*/_react.default.createElement(_button.default, {
    onClick: () => onChange(null)
  }, "Replace Image")) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, document && document.fileError ? /*#__PURE__*/_react.default.createElement(_alert.default, {
    type: "danger"
  }, document.fileError) : null, /*#__PURE__*/_react.default.createElement(_FilePicker.default, {
    onFile: files => {
      if (files.length) {
        const file = files[0];
        function upload() {
          onChange({
            file,
            fileID: uploadIdentityDocument(file).catch(ex => {
              if (currentFile.current === file) {
                onChange({
                  file: null,
                  fileID: null,
                  fileError: ex.message,
                  refresh: undefined
                });
              }
              throw ex;
            }),
            fileError: null,
            refresh: upload
          });
        }
        upload();
      }
    }
  })));
}